import type { FunctionComponent } from 'react'

import { Route, Switch } from 'react-router-dom'
import styled from 'styled-components'

import type { WhiteLabelSubdomainInfo } from '../../api/budgetApiClient'

import { BudgetHelper } from './BudgetHelperFlow'
import { BudgetHelperLandingPage } from './BudgetHelperLandingPage'
import { BudgetHelperPageLayout } from './BudgetHelperPageLayout'

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	gap: 32px;
`

export const IconWrapper = styled.div`
	z-index: 4;
`

export const BudgetHelperRoutes: FunctionComponent<{
	subdomainInfo: WhiteLabelSubdomainInfo
	consumerInputsStepIndex?: number
}> = ({ subdomainInfo, consumerInputsStepIndex }) => {
	return (
		<Switch>
			<Route exact path="/budget-helper/questionnaire/:step">
				<BudgetHelperPageLayout
					subdomainInfo={subdomainInfo}
					consumerInputsStepIndex={consumerInputsStepIndex}
				>
					<BudgetHelper />
				</BudgetHelperPageLayout>
			</Route>
			<Route path="*">
				<BudgetHelperLandingPage
					subdomainInfo={subdomainInfo}
					consumerInputsStepIndex={consumerInputsStepIndex}
				/>
			</Route>
		</Switch>
	)
}
